import { render, staticRenderFns } from "./createRequest.vue?vue&type=template&id=17b2265c&scoped=true&"
import script from "./createRequest.vue?vue&type=script&lang=js&"
export * from "./createRequest.vue?vue&type=script&lang=js&"
import style0 from "./createRequest.vue?vue&type=style&index=0&id=17b2265c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2265c",
  null
  
)

export default component.exports